import React from "react"
import Radium from "radium"

const _blueButton = (disabled) => ({
    cursor: 'pointer',
    display: 'inline-block',
    minHeight: '1em',
    outline: 0,
    border: '1px solid #5f9be0',
    verticalAlign: 'baseline',
    backgroundColor: disabled ? '#D3D3D3' : '#ffffff',
    color: disabled ? '#a2a2a2' : '#5f9be0',
    fontFamily: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
    margin: '0 .25em 0 0',
    padding: '.78571429em 1.5em .78571429em',
    textTransform: 'none',
    textShadow: 'none',
    fontWeight: 700,
    lineHeight: '1em',
    fontStyle: 'normal',
    textAlign: 'center',
    textDecoration: 'none',
    borderRadius: '.28571429rem',
    boxShadow: '0 0 0 1px transparent inset, 0 0 0 0 rgba(34,36,38,.15) inset',
    transition: 'opacity .1s ease,background-color .1s ease,color .1s ease,box-shadow .1s ease,background .1s ease',
    ':hover':{
        backgroundColor: '#f5f5f5',
        boxShadow: '0 0 0 1px transparent inset, 0 0 0 0 rgba(34,36,38,.15) inset',
        color: '#5e92d6'
    },
    ':active': {
        backgroundColor: '#e6e6e6',
        color: '#5e83c7'
    }

})

const BlueButton = ({text, style, disabled, onClick }) => {
    return (
        <button style={{..._blueButton(disabled), ...style}} disabled={disabled} onClick={(e) => {e.preventDefault();onClick()}}>{text}</button>
    )
}

export default Radium(BlueButton)